(() => {
  const initFragranceTabs = (root = document) => {
    root.querySelectorAll('[data-fragrance-tabs]').forEach((section) => {
      if (section.dataset.fragranceTabsInitialized === 'true') return;
      section.dataset.fragranceTabsInitialized = 'true';

      const tabs = section.querySelectorAll('[data-fragrance-tab]');
      const panels = section.querySelectorAll('[data-fragrance-panel]');
      const tabList = section.querySelector('.fragrance-tabs__tabs');

      tabList?.style.setProperty('--fragrance-tab-count', tabs.length);

      const movePill = (tab) => {
        if (!tabList || !tab) return;
        const styles = getComputedStyle(tab);
        tabList.style.setProperty('--fragrance-pill-x', `${tab.offsetLeft}px`);
        tabList.style.setProperty('--fragrance-pill-y', `${tab.offsetTop}px`);
        tabList.style.setProperty('--fragrance-pill-width', `${tab.offsetWidth}px`);
        tabList.style.setProperty('--fragrance-pill-height', `${tab.offsetHeight}px`);
        tabList.style.setProperty('--fragrance-pill-color', styles.getPropertyValue('--fragrance-tab-active-bg').trim());
        tabList.style.setProperty('--fragrance-pill-border', styles.getPropertyValue('--fragrance-tab-active-border').trim());
        tabList.classList.add('is-pill-ready');
      };

      movePill(section.querySelector('[data-fragrance-tab].is-active'));

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const targetId = tab.getAttribute('data-target');

          tabs.forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          movePill(tab);

          panels.forEach((panel) => {
            if (panel.id === targetId) {
              panel.classList.add('is-active');
              panel.removeAttribute('hidden');
            } else {
              panel.classList.remove('is-active');
              panel.setAttribute('hidden', '');
            }
          });
        });
      });

      if (tabList && 'ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          movePill(section.querySelector('[data-fragrance-tab].is-active'));
        });
        resizeObserver.observe(tabList);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initFragranceTabs());
  document.addEventListener('shopify:section:load', (event) => initFragranceTabs(event.target));
})();
